module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAMAAACgjTZZAAAAA1BMVEX///+nxBvIAAAAFUlEQVR42pXBAQEAAACAkP6vtiHaAAAyAAGiCcttAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ideate/bottom.png
// module id = 179
// module chunks = 35783957827783 112966903596346 114276838955818